import PropTypes from 'prop-types';
import OrganisationItem from '../organisation/OrganisationItem';

function SuggestedOrganisationItem({suggestion}) {
  return (
    <div className='mb-3'>
      <OrganisationItem
        isSuggestion={true}
        organisation={{
          ...suggestion,
          fullName: suggestion.invitingOrganisationName
        }}
      />
    </div>
  );
}

SuggestedOrganisationItem.propTypes = {
  suggestion: PropTypes.shape({
    invitingOrganisationName: PropTypes.string.isRequired,
    organisationId: PropTypes.number.isRequired,
    country: PropTypes.string.isRequired,
    registrationNumber: PropTypes.string.isRequired,
    address: PropTypes.shape({
      addressLine: PropTypes.string.isRequired,
      postCode: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default SuggestedOrganisationItem;
